"use client";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

export interface LoadingRefreshProps {
  loading?: boolean;
}

export default function LoadingRefresh({
  loading = true,
}: LoadingRefreshProps) {
  if (!loading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
    >
      <LinearProgress />
    </Box>
  );
}
